import { VehicleType } from "@/services/VehicleType";
import { DropDownItem } from "@/services/DropDownItem";
import { LubricationTable } from "@/services/LubricationTable";
export class Vehicle {
    constructor(idVehicle?: string, 
        gearBoxModel?: string,
        vehicleCode?:number,
        idVehicleType?:string,
        brand?:DropDownItem,
        builder?:DropDownItem,
        fuel?:DropDownItem,
        gearBoxType?:DropDownItem,
        traction?:DropDownItem,
        dateLastInfoUpdate?: string,
        model?:string,
        yearOfRegistration?:number,
        displacement?:number,
        staging?:string,
        idProduction?: string,
        production?: DropDownItem,
        motorType?:string,lubricationTables?:Array<LubricationTable>) {
        (idVehicle) ? this.idVehicle = idVehicle : this.idVehicle = null;
        (vehicleCode) ? this.vehicleCode = vehicleCode : this.vehicleCode = null;
        this.gearBoxModel = gearBoxModel;
        // (vehicleType) ? this.vehicleType = vehicleType : this.vehicleType = new VehicleType();
        (idVehicleType) ? this.idVehicleType = idVehicleType : this.idVehicleType = null;
        (brand)? this.brand = brand : this.brand = new DropDownItem();
        (builder) ? this.builder = builder : this.builder = new DropDownItem();
        (fuel) ? this.fuel = fuel : this.fuel = new DropDownItem();
        (gearBoxType) ? this.gearBoxType = gearBoxType : this.gearBoxType = new DropDownItem();
        (traction) ? this.traction = traction : this.traction = new DropDownItem();
        (production) ? this.production = production : this.production = new DropDownItem();
        this.dateLastInfoUpdate = dateLastInfoUpdate;
        this.model = model;
        this.yearOfRegistration = yearOfRegistration;
        this.displacement = displacement;
        this.staging = staging;
        this.motorType = motorType;
        (lubricationTables != null || lubricationTables != undefined) ? this.lubricationTables = lubricationTables : this.lubricationTables = new Array<LubricationTable>();

    };
    public idVehicle: string;
    public vehicleCode:number;
    public gearBoxModel: string;
    public idVehicleType:string;
    public brand:DropDownItem;
    public builder:DropDownItem;
    public fuel:DropDownItem;
    public gearBoxType:DropDownItem;
    public traction:DropDownItem;
    public production:DropDownItem;
    public dateLastInfoUpdate: string;
    public model:string;
    public yearOfRegistration:number;
    public displacement:number;
    public staging:string;
    public motorType:string;
    public lubricationTables:Array<LubricationTable>;
}